{
  "names": {
    "Fajr": "Alfajiri",
    "Dhuhr": "Adhuhuri",
    "Asr": "Alasiri",
    "Maghrib": "Magharibi",
    "Isha": "Isha"
  },
  "card": {
    "label": "Sala inayofuata",
    "labelTomorrow": "Kesho · {{prayer}}",
    "inHoursMinutes": "baada ya saa {{hours}} dk {{minutes}}",
    "inMinutes": "baada ya dk {{minutes}}",
    "open_aria": "Fungua nyakati za sala",
    "pro": "Rhemn Pro",
    "unlock_aria": "Fungua nyakati za sala kwa Rhemn Pro",
    "unavailable": "Nyakati za sala hazipatikani kwa sasa."
  },
  "sheet": {
    "bellOn_aria": "Zima ukumbusho wa {{prayer}}",
    "bellOff_aria": "Washa ukumbusho wa {{prayer}}",
    "explainer": "Pata ukumbusho mpole kwa kila sala. Vikumbusho ni arifa kimya — hakuna sauti kwa chaguo-msingi.",
    "enableReminders": "Washa vikumbusho",
    "enableInSettings": "Washa arifa za Rhemn katika Mipangilio ili kupokea vikumbusho vya sala.",
    "openSettings": "Fungua Mipangilio"
  },
  "notifications": {
    "body": "Ni wakati wa sala."
  },
  "focus": {
    "label": "Swala ya {{prayer}}",
    "close_aria": "Funga skrini ya swala",
    "hint": "Bonyeza Esc au × ili kurudi",
    "phrases": {
      "accepted": "Allah aikubali swala yako",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Anza kwa nia. Endelea kwa baraka.",
    "prayerApproaches": "Swala yako ijayo inakaribia. Baki imara katika nia yako.",
    "morningPursue": "Asubuhi yenye baraka ya kufuatilia: {{focus}}",
    "dayCloses": "Siku inapomalizika, tafakari kuhusu: {{focus}}",
    "fulfilled": "Umetimiza nia yako leo. Alhamdulillah.",
    "workingTowards": "Leo unafanya kazi kuelekea: {{focus}}",
    "prayerNear": "Swala yako ijayo iko karibu. Vuta pumzi."
  },
  "widget": {
    "countdown": "baada ya {{time}}",
    "openToUpdate": "Fungua Rhemn ili kusasisha",
    "openForVerse": "Fungua Rhemn kwa aya ya leo"
  }
}
